import React from 'react';
//IMPORTS MATERIAL UI
import Fab from '@material-ui/core/Fab';
import DeleteIcon from '@material-ui/icons/Delete'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';
import { makeStyles } from '@material-ui/core/styles';
//NOTIFICATIONS
import AddAlert from "@material-ui/icons/AddAlert";
import Snackbar from "./Snackbar.js";
import styles from "./jqwidgets/styles/notificationsStyle";
const useStylesNotifications = makeStyles(styles);
//CREATE STYLES
const useStyles = makeStyles(theme => ({
  textField: {
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
  },
}));

export default function FormDialog(props) {

  const [open, setOpen] = React.useState(false)//MODAL STATE
  const data = props.data//DATAFIELDS
  var rowData = props.rowData
  const id = props.id
  const listDeleteIds = props.listDeleteIds
  const classes = useStyles();
  //NOTIFICATIONS
  const [tc, setTC] = React.useState(false);
  const classesNotifications = useStylesNotifications();
  const showNotification = () => {
    if (!tc) {
      setTC(true);
      setTimeout(function() {
        setTC(false);
      }, 6000);
    }
  
  }
    function handleClickOpen() {
      setOpen(true);
    }
  
    function handleClose() {
      setOpen(false);
    }

    function createDeleteContent(name){
      return (
        <TextField 
          key={name} 
          className={classes.textField} 
          autoFocus 
          margin={'normal'} 
          InputLabelProps={{shrink: true,}} 
          variant={'outlined'} 
          id={name} 
          type={'text'} 
          name={name} 
          defaultValue={rowData[name]}
          label={getLabel(name)}
          disabled={true}
          fullWidth/>
          ) 
    }

    function getLabel(datafield){
      return datafield.toUpperCase()
    }

    function buildBody(){
      var keyData = new Object()
      var data = new Object()
        keyData[props.record+props.id]=rowData[id]
        keyData['active']=false//PARCHE
        data[props.record]=keyData
        return data
    }

    function del(e){
      var body = buildBody()
      e.preventDefault()
      console.log(JSON.stringify(body))
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', props.host+props.entity, true);//PARCHE
      //Send the proper header information along with the request
      xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
      xhr.send(JSON.stringify(body));
      xhr.onreadystatechange = function() { // Call a function when the state changes.
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
          // showNotification()
          alert('An  element has been deleted')
          props.onClick(true)
          }else{
          console.log('Error during delete')
        }
    }
    handleClose()
  }

  function deleteId(id,callBack){
    var data = new Object()
    var body = new Object()
      data[props.record+props.id]=id
      body[props.record]=data
      console.log(JSON.stringify(body))
    //   var xhr = new XMLHttpRequest();
    //   xhr.open('DELETE', props.host+props.entity, true);
    //   //Send the proper header information along with the request
    //   xhr.setRequestHeader('Content-type', 'application/json; charset=UTF-8')
    //   xhr.send(JSON.stringify(body));
    //   xhr.onreadystatechange = function() { // Call a function when the state changes.
    //  if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
    //      return true
    //  }else{
    //    return false
    //  }
    // }
    var headers = new Headers()//HEADERS FOR FETCH
        // var root =  this.props.root//ROOT DATAFIELD
        // let url = this.props.host+this.props.entity+'/'+entity+'/'+foreignKey//BUILD FETCH API
        let url =  props.host+props.entity//BUILD FETCH API
        headers.append('Content-Type','application/json')//ADD HEADERS TO MAKE REQUEST
        var init = { method: 'DELETE',
                  headers: headers
                    };
        fetch(url, init)
        .then(function(response) {
            if(response.ok){
                return response.json()//MAKE RESPONSE TO JSON DATA
            }
        })
        .then(function(json){
            callBack (json)//RETURN JSON DATA
        })
        .catch(function(error){
            console.log(error)//SHOW ERROR DETAILS IN CONSOLE
        })
  }

  function delBundle(e){

    e.preventDefault()
    for(let i=0;i<listDeleteIds.length;i++){
    deleteId(listDeleteIds[i], res=>{
      console.log(res)
      })
    }
    handleClose()
    props.onClick(true)
  }

if(listDeleteIds.length>1){// CREATE FORM WITH FOREIGN KEYS COMPONENTS
  return (
    <div align={'right'}>
      <Fab size={'small'} color="secondary" aria-label="delete" onClick={handleClickOpen}>
        <DeleteIcon />
      </Fab>
      <Dialog 
      open={open} 
      onClose={handleClose} 
      aria-labelledby="form-dialog-title">
        <DialogTitle >DELETE BUNDLE</DialogTitle>        
        <form className={'commentForm'} onSubmit={delBundle} method={'DELETE'}>
        <DialogContent align={'left'}>
          <DialogContentText id="alert-dialog-description">
              Are you sure to delete these {listDeleteIds.length} items?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={handleClose} color={'secondary'}>
            No
          </Button>
          <Button variant={'contained'} type={'submit'} color={'primary'}>
            Yes
          </Button>
        </DialogActions>        
        </form>
      </Dialog>
      <Snackbar
        place="tc"
        color="info"
        icon={AddAlert}
        message="Welcome to MATERIAL DASHBOARD PRO - a beautiful admin panel for every web developer."
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
    </div>
  );
}else if(rowData==null){//CREATE NORMAL FORM
  return (
    <div align={'right'}>
      <Fab size={'small'} color="secondary" aria-label="delete" onClick={handleClickOpen}>
        <DeleteIcon />
      </Fab>
      <Dialog 
      open={open} 
      onClose={handleClose} 
      aria-labelledby="form-dialog-title">
        <DialogTitle >Select an item</DialogTitle>        
        <DialogContent align={'left'}>
          <DialogContentText id="alert-dialog-description">
              Please select an item from Grid.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={handleClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>        
      </Dialog>
    </div>
  )
}else{
  return (
    <div align={'right'}>
      <Fab size={'small'} color="secondary" aria-label="delete" onClick={handleClickOpen}>
        <DeleteIcon />
      </Fab>
      <Dialog 
      open={open} 
      onClose={handleClose} 
      aria-labelledby="form-dialog-title">
        <DialogTitle >DELETE {getLabel(props.record)}?</DialogTitle>        
        <form className={'commentForm'} onSubmit={del} method={'DELETE'}>
        <DialogContent align={'left'}>
          {data.map((element)=>
            createDeleteContent(element.name)
          )}
        </DialogContent>
        <DialogActions>
          <Button variant={'contained'} onClick={handleClose} color={'secondary'}>
            No
          </Button>
          <Button variant={'contained'} type={'submit'} color={'primary'}>
            Yes
          </Button>
        </DialogActions>        
        </form>
      </Dialog>
      <Snackbar
        place="tc"
        color="info"
        icon={AddAlert}
        message="Welcome to MATERIAL DASHBOARD PRO - a beautiful admin panel for every web developer."
        open={tc}
        closeNotification={() => setTC(false)}
        close
      />
    </div>
    )
  }
}